import React, { useCallback, useState, useEffect, useMemo } from 'react';
import MapContainer from 'components/GoogleMap/MapContainer';
import Map from 'components/GoogleMap';
import { FETCH_COUNTRY_SITES } from '../provider/constants';
import ModalAside from './ModalAside';
import Grid from '@material-ui/core/Grid';
import SimpleList from 'components/List/simple';
import Modal from 'components/Modal';
import { connect } from 'react-redux';
import ProgressBar from 'components/ProgressLoader';
import { Box } from '@material-ui/core';
import getValue from 'lodash/get';

const accessor = {
  id: 'site_id',
  name: 'site_name',
  address: 'site_address',
  distance: 'site_distance',
  lat: 'site_location.lat',
  lng: 'site_location.lng',
  link: 'site_eligibility',
  status: 'site_status',
};
const CountryDetails = (props) => {
  const {
    list = {},
    resultLoading = false,
    resultError = false,
    addressText,
    siteText,
    prescreenButtonText,
    onSiteConnectClick,
    distanceUnit,
    trialId,
    primaryColor = '#213a83',
    google_place_api_key = ''
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  // const [zoom, setZoom] = useState(1);
  const [center, setCenter] = useState({ lat: 0, lng: 0 });

  const handleItemClick = useCallback(
    (activeItem) => {
      setModalData(activeItem);
      setModalOpen(true);
    },
    [setModalData],
  );

  useEffect(() => {
    setCenter(modalData.site_location);
  }, [modalData]);
  const data = useMemo(() => {
    return [modalData];
  }, [modalData]);

  return (
    <Grid md={12} item>
      <Box my={2}>
        <Grid container justify="center">
          {resultLoading && <ProgressBar type="circular" />}
          {resultError && <div>{resultError}</div>}
        </Grid>
        <Grid container spacing={4}>
          {list.map((stateObj, index) => (
            <Grid sm={6} md={4} item>
              <SimpleList
                key={index}
                heading={stateObj.state}
                list={stateObj.sites}
                onClick={handleItemClick}
                accessor={{ label: accessor.name }}
              />
            </Grid>
          ))}
        </Grid>
        <Modal
          open={modalOpen}
          onChange={setModalOpen}
          modalProps={{ keepMounted: true }}
        >
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} md={4} item>
              <ModalAside
                trialId={trialId}
                modalData={modalData}
                accessor={accessor}
                onSiteConnectClick={onSiteConnectClick}
                distanceUnit={distanceUnit}
                setModalOpen={setModalOpen}
                {...{ addressText, siteText, prescreenButtonText }}
              />
            </Grid>
            <Grid xs={12} sm={8} md={8} item>
              <MapContainer height={400}>
                <Map
                  data={data}
                  accessor={accessor}
                  //activeId={null}
                  // activeItem={modalData}
                  handleMarkerClick={() => {
                    setCenter(modalData.site_location);
                  }}
                  center={center}
                  setCenter={setCenter}
                  infoDisabled={true}
                  noMarkerText={true}
                  // infoAccessorList={[
                  // { accessor: accessor.name, isTitle: true, color: "primary" },
                  // { label: "Address", fullWidth: true, accessor: accessor.address },
                  // { label: "Status", accessor: accessor.status }
                  // ]}
                  primaryColor={primaryColor}
                  google_place_api_key = {google_place_api_key}
                />
              </MapContainer>
            </Grid>
          </Grid>
        </Modal>
      </Box>
    </Grid>
  );
};
function mapStateToProps({ api, countrySites, trial, theme_config }) {
  const primaryColor = state.theme_config && state.theme_config.primary
  return {
    list: countrySites.data,
    stateCount: countrySites.state_count,
    total: countrySites.site_count,
    resultLoading: api.loading[FETCH_COUNTRY_SITES],
    resultError: api.error[FETCH_COUNTRY_SITES],
    trialId: getValue(trial, 'id', null),
    primaryColor
  };
}

export default connect(mapStateToProps)(CountryDetails);
